import { Injectable } from '@angular/core';
import { DynamicForm } from 'app/shared/models/enum/dynamic-form';

@Injectable()
export class SystemSettingsService {

    getDynamicFormByName(input: DynamicForm) {
        const state = JSON.parse(this.getDynamicFormDataSynchronous())
        return state[input.toString()];
    }

    getDynamicFormDataSynchronous() {
        var request = new XMLHttpRequest();
        request.open('GET', 'assets/data/dynamic.form.json', false);  // `false` 

        request.send(null);
        return request.responseText;
    }
}

